export const customPresets = [
  "TODAY",
  "LAST_7_DAYS",
  "THIS_WEEK",
  "THIS_MONTH",
  "THIS_YEAR",
  "LAST_WEEK",
  "LAST_MONTH",
  "LAST_YEAR",
] as const;

export type CustomPreset = (typeof customPresets)[number];
